import { UserRoles } from '../../api/queries.ts';

export class TeamLeaderRolesUtils {
  /**
   * The team leader's part of the app (the team dashboards, surveys and teams) is for those who lead a team, and for
   * the organization's administrator, who sets up the teams. HR, safety representatives and members who lead no team
   * see their teams from their own part, if at all. The API checks each team by itself.
   */
  public static hasTeamLeaderPart(userRoles: ReadonlyArray<string> = [], leadsTeam = false): boolean {
    return leadsTeam || userRoles.includes(UserRoles.ORG_ADMIN);
  }
}
